import Heading from '@tiptap/extension-heading'
import { baseExtensions } from '../extensions/base-extensions'

export const getExtensions = (enableHeadings: boolean) => {
  const dependecies = [...baseExtensions]
  if (enableHeadings) {
    dependecies.push(Heading)
  }

  return dependecies
}
